module.exports = __webpack_public_path__ + "img/ukflag.389e351c.svg";